// extracted by mini-css-extract-plugin
module.exports = {"title":"_427a6d","valueForMoneyContainer":"_b4b49f","snippetContainer":"_84b2c7","reviewsBtn":"_f0b81c"};